export default __webpack_public_path__ + "static/media/blade_diffuse.2d1b48d4.jpg";